import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicSslCertificateGenerateParamsRaw,
	LWApiPublicSslCertificateGenerateResultRaw,
} from '@liquidweb-dev/club-sauce/public/ssl/certificate/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';

import api from 'modules/queries/api';
import { DOMAIN_LIST_QUERY_KEY } from 'modules/queries/domain/useList';
import { SSL_CERTIFICATE_LIST_QUERY_KEY } from './useList';

const useSslCertificateGenerate = () => {
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicSslCertificateGenerateResultRaw,
		ApiErrorI,
		LWApiPublicSslCertificateGenerateParamsRaw
	>({
		mutationFn: (params) => api.ssl.certificate.apiRaw.generate(params),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [SSL_CERTIFICATE_LIST_QUERY_KEY],
			});
			queryClient.invalidateQueries({ queryKey: [DOMAIN_LIST_QUERY_KEY] });
		},
	});
};

export default useSslCertificateGenerate;
